import { NavBar } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

const NavigationBrands = () => {
  return (
    <AppSubNav>
      <NavBar.Item href={{ pathname: "/brands" }}>{t`Brands`}</NavBar.Item>
      <NavBar.Item href={{ pathname: "/clients" }}>{t`Clients`}</NavBar.Item>
    </AppSubNav>
  );
};

export default observer(NavigationBrands);
